import React from "react";
import PropTypes from "prop-types";
import { Clock, CollapsibleSection, MarkerPin01 } from "@opendate-app/setlist";
import { SCOPE_TEAM, SCOPE_VENUES, formatCents } from "../../GiftCardProducts/giftCardFormat";
import { productShape, teamShape } from "../giftCardPurchasePropTypes";

const MONTHS_PER_YEAR = 12;

export const whereItWorks = (product, teamName) => {
  if (product.scope === SCOPE_TEAM) return `Works at any ${teamName} venue`;
  if (product.scope === SCOPE_VENUES) return `Works at ${product.venueNames.join(", ")}`;
  return "Works at any Opendate venue";
};

export const expiryLine = (expiresInMonths) => {
  if (!expiresInMonths) return "Never expires";
  if (expiresInMonths % MONTHS_PER_YEAR === 0) return `Expires ${expiresInMonths / MONTHS_PER_YEAR} years after purchase`;
  return `Expires ${expiresInMonths} months after purchase`;
};

const GiftCardDetails = ({ product, team, currency, amountCents }) => (
  <section className="gift-card-purchase-details" aria-label="Gift card details">
    <div
      className="gift-card-purchase-art"
      style={{
        ...(team.accentColor ? { backgroundColor: team.accentColor } : {}),
        ...(product.artworkUrl ? { backgroundImage: `url("${product.artworkUrl}")` } : {}),
      }}
      data-testid="gift-card-purchase-art"
    >
      <span className="gift-card-purchase-art-team">{team.name}</span>
      <div className="gift-card-purchase-art-footer">
        <span>Gift card</span>
        {amountCents ? (
          <span className="gift-card-purchase-art-amount">{formatCents(amountCents, currency, { whole: true })}</span>
        ) : null}
      </div>
    </div>
    <h1 className="gift-card-purchase-name">{product.name}</h1>
    <ul className="gift-card-purchase-facts">
      <li>
        <MarkerPin01 aria-hidden="true" />
        {whereItWorks(product, team.name)}
      </li>
      <li>
        <Clock aria-hidden="true" />
        {expiryLine(product.expiresInMonths)}
      </li>
    </ul>
    {product.terms ? (
      <CollapsibleSection title="Terms" size="sm">
        <p className="gift-card-purchase-terms">{product.terms}</p>
      </CollapsibleSection>
    ) : null}
  </section>
);

GiftCardDetails.propTypes = {
  product: productShape.isRequired,
  team: teamShape.isRequired,
  currency: PropTypes.string.isRequired,
  amountCents: PropTypes.number,
};

export default GiftCardDetails;
